import { useState } from "react";
import ParkingLogin from "./flows/LoginFlow/ParkingLogin";
import ForgotPassword from "./flows/LoginFlow/ForgotPassword";
import Dashboard from "./flows/DashboardFlow/Dashboard";
import Settings from "./flows/SettingsFlow/Settings";
import Checkin from "./flows/Check-inFlow/checkin";
import Vehicle from "./flows/VehicleFlow/Vehicle";

import Analytics from "./flows/AnalyticsFlow/Analytics";

function App() {
  const [page, setPage] = useState("login");

  return (
    <>
      {page === "login" && <ParkingLogin setPage={setPage} />}
      {page === "forgot" && <ForgotPassword setPage={setPage} />}
      {page === "dashboard" && <Dashboard setPage={setPage} />}
      {page === "settings" && <Settings setPage={setPage} />}
      {page === "checkin" && <Checkin setPage={setPage} />}
      {page === "analytics" && <Analytics setPage={setPage} />}
      {page === "vehicle" && <Vehicle setPage={setPage} />}

    </>
  );
}

export default App;